import { Component } from '@angular/core';

@Component({
  selector: 'app-purchases-by-supplier-report',
  templateUrl: './purchases-by-supplier-report.component.html',
  styleUrls: ['./purchases-by-supplier-report.component.scss'],
})
export class PurchasesBySupplierReportComponent {}
